// import dayjs from "dayjs";
import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getBizLayerQuery(oauthTokenHeader: any) {
  return fetchWrapper.get(`${apiUrl}/biz_layer_query/`, oauthTokenHeader);
}

function getBizLayerQueryById(oauthTokenHeader: any, id: any) {
  return fetchWrapper.get(`${apiUrl}/biz_layer_query/${id}/`, oauthTokenHeader);
}

function getBizLayerQueryModules(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/modules`,
    oauthTokenHeader
  );
}

function postMetaData(oauthTokenHeader: any, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/biz_layer_query/db_metadata/`,
    data,
    oauthTokenHeader
  );
}
function postBizLayerQuery(oauthTokenHeader: any, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/biz_layer_query/`,
    data,
    oauthTokenHeader
  );
}

function putBizLayerQuery(oauthTokenHeader: any, data: any, query_id: any) {
  return fetchWrapper.put(
    `${apiUrl}/biz_layer_query/${query_id}/`,
    data,
    oauthTokenHeader
  );
}
function deleteBizLayerQuery(oauthTokenHeader: any, query_id: any) {
  return fetchWrapper.delete(
    `${apiUrl}/biz_layer_query/${query_id}/`,
    oauthTokenHeader
  );
}

function runBizLayerQuery(oauthTokenHeader: any, query_id: any, inputs: any) {
  const params = new URLSearchParams() as any;

  Object.keys(inputs).forEach((key) => {
    if (key.endsWith("-key")) {
      const prefix = key.split("-")[0];
      const title = inputs[`${prefix}-key`];
      let value = inputs[`${prefix}-value_for_test`];

      // clean up strings
      if (typeof value === "string") {
        value = value.replace(/^['"]|['"]$/g, "");
      }

      if (title && value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // 🔹 append each UID separately
          value.forEach((v) => {
            params.append(title, v);
          });
        } else {
          params.append(title, value);
        }
      }
    }
  });

  const url = `${apiUrl}/biz_layer_query/run/${query_id}/?${params.toString()}`;
  return fetchWrapper.get(url, oauthTokenHeader);
}

export const dataStoreServeices = {
  getBizLayerQuery,
  getBizLayerQueryById,
  getBizLayerQueryModules,
  postMetaData,
  postBizLayerQuery,
  putBizLayerQuery,
  deleteBizLayerQuery,
  runBizLayerQuery,
};
